module.exports = __webpack_public_path__ + "img/logoDalal.9c7696c9.png";